import { render, staticRenderFns } from "./MessagesBoardViewer.vue?vue&type=template&id=3907eb0f&scoped=true&"
import script from "./MessagesBoardViewer.vue?vue&type=script&lang=ts&"
export * from "./MessagesBoardViewer.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesBoardViewer.vue?vue&type=style&index=0&id=3907eb0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907eb0f",
  null
  
)

export default component.exports